import Skeleton from "react-loading-skeleton";
import styles from "./product-page-skeleton.module.css";

const ProductPageSkeleton = () => {
  return (
    <div className={styles.container}>
      <div className={styles.gallery}>
        <div className={styles.mainImage}>
          <Skeleton width="100%" height="100%" />
        </div>
        <div className={styles.thumbnailRow}>
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={index} className={styles.thumbnail}>
              <Skeleton width="100%" height="100%" />
            </div>
          ))}
        </div>
      </div>

      <div className={styles.details}>
        <div className={styles.metaLine}>
          <Skeleton width="42%" height={12} />
        </div>

        <div className={styles.titleBlock}>
          <Skeleton width="96%" height={42} className={styles.titlePrimary} />
          <Skeleton width="72%" height={42} />
        </div>

        <div className={styles.contentBlock}>
          <Skeleton width="34%" height={22} />
          <div className={styles.copyBlock}>
            <Skeleton width="100%" height={12} />
            <Skeleton width="94%" height={12} />
            <Skeleton width="80%" height={12} />
          </div>

          <div className={styles.optionBlock}>
            <Skeleton width="26%" height={12} />
            <div className={styles.swatchRow}>
              {Array.from({ length: 4 }).map((_, index) => (
                <Skeleton key={index} width={36} height={36} />
              ))}
            </div>
          </div>

          <div className={styles.optionBlock}>
            <Skeleton width="18%" height={12} />
            <div className={styles.sizeRow}>
              {Array.from({ length: 4 }).map((_, index) => (
                <Skeleton key={index} width={58} height={44} />
              ))}
            </div>
          </div>

          <div className={styles.footerBlock}>
            <Skeleton width="100%" height="100%" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductPageSkeleton;
